module.exports = __webpack_public_path__ + "static/media/action.456402dc.svg";